/*
    Default Section Divs
    - height: default is h-[85vh], can be overridden using Tailwind classes
*/
export function SectionDiv({ children, className, height, padding="px-4 py-2", margin="mx-auto" }: { children: React.ReactNode; className?: string; height?: string; padding?: string; margin?: string; }) {
    return (
        <div className={`shadow-md rounded-lg border-2 w-full overflow-hidden bg-white dark:bg-stone-900 ${height ? height : "h-[85vh]"} ${className} ${padding} ${margin}`}>
            {children}
        </div>
    );
}
